<div class="dialog-container">
  <div class="dialog-content">
    <h3>
      {{ data.fertilizationBalanceSetting.name }} ({{
        data.fertilizationBalanceSetting.areaInHectares | number: '0.1-2'
      }}
      ha)
    </h3>

    <img src="assets/uni.png" alt="uni" class="animated-icon" [class.spinning]="isTyping" />

    <form [formGroup]="form">
      <div class="coordinates-row">
        <mat-form-field appearance="outline" class="coordinate-field" subscriptSizing="dynamic">
          <mat-label>{{ 'fertilizationBalance.DialogLatitude' | translate }}</mat-label>
          <input matInput type="number" formControlName="latitude" step="any" />
          @if (form.controls.latitude.hasError('required')) {
            <mat-error>{{ 'fertilizationBalance.latitudeRequired' | translate }}</mat-error>
          } @else if (form.controls.latitude.invalid) {
            <mat-error>{{ 'fertilizationBalance.latitudeInvalid' | translate }}</mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline" class="coordinate-field" subscriptSizing="dynamic">
          <mat-label>{{ 'fertilizationBalance.DialogLongitude' | translate }}</mat-label>
          <input matInput type="number" formControlName="longitude" step="any" />
          @if (form.controls.longitude.hasError('required')) {
            <mat-error>{{ 'fertilizationBalance.longitudeRequired' | translate }}</mat-error>
          } @else if (form.controls.longitude.invalid) {
            <mat-error>{{ 'fertilizationBalance.longitudeInvalid' | translate }}</mat-error>
          }
        </mat-form-field>
      </div>

      <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic">
        <mat-label>{{ 'fertilizationBalance.DialogRemarks' | translate }}</mat-label>
        <input matInput type="tel" formControlName="remarks" maxlength="256" autocomplete="off" />
        @if (form.get('remarks')?.hasError('invalidMobilePhone')) {
          <mat-error>{{ 'fertilizationBalance.invalidMobilePhone' | translate }}</mat-error>
        }
        @if (form.get('remarks')?.hasError('maxlength')) {
          <mat-error>
            {{ 'fertilizationBalance.remarksMaxLengthError' | translate }}
          </mat-error>
        }
      </mat-form-field>
    </form>
  </div>
  <div class="dialog-actions">
    <button mat-flat-button (click)="cancel()">{{ 'close' | translate }}</button>
    <button
      mat-flat-button
      [color]="isRemoval ? 'warn' : 'primary'"
      (click)="confirm()"
      [disabled]="!canConfirm"
    >
      {{ (isRemoval ? 'fertilizationBalance.removeReferenceBlock' : 'confirm') | translate }}
    </button>
  </div>
</div>
